export async function copyText(value: string): Promise<void> {
  await navigator.clipboard.writeText(value);
}

export function partnerBillCopyText(input: { order: string; partner: string; billNumber: string; amount: string; route: string }): string {
  return [`Order: ${input.order}`, `Partner: ${input.partner}`, `Bill no.: ${input.billNumber}`, `Route: ${input.route}`, `Amount: ${input.amount}`].join('\n');
}
